import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useChakraFocusRef
} from '~/design_system'
import { Msg } from '~/common/localizationUtils'

interface TasksConfirmBulkActionParams {
  title: string
  descriptionSuffix: string
  isOpen: boolean
  onClose: any
  onProceed: (x: any) => void
  isLoading: boolean
}
export const TasksConfirmBulkAction = ({
  title,
  descriptionSuffix,
  isOpen,
  onClose,
  onProceed,
  isLoading
}: TasksConfirmBulkActionParams) => {
  const cancelRef = useChakraFocusRef<HTMLButtonElement>()

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader textStyle="heading3" textAlign="center">
          {title}
        </AlertDialogHeader>

        <AlertDialogBody textAlign="center">
          <Msg
            id="tasks_confirm_bulk_action.are_you_sure_you_want_to"
            description="Are you sure you want to {descriptionSuffix}?"
            descriptionSuffix={descriptionSuffix}
          />
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button
            data-testid="bulk-update-confirm-btn"
            variant="primary"
            onClick={onProceed}
            isLoading={isLoading}
            mr={3}>
            <Msg id="common.ui.yes" description="Yes" />
          </Button>
          <Button
            data-testid="bulk-update-cancel-btn"
            variant="secondary"
            ref={cancelRef}
            onClick={onClose}
            isDisabled={isLoading}>
            <Msg id="common.ui.cancel" description="Cancel" />
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
